(function () {
  angular
    .module('BuscaAtivaEscolar')
    .service('HandleErrorResponsesInterceptor', function () {
      function handleResponse(response) {
        if (!response) {
          return handleEmptyResponse();
        }

        if (response.status === 401 || response.statusText === "Unauthorized") {
          // Se houver um erro mapeado no response.data.error, não redireciona
          if (response.data && response.data.error) {
            return response;
          } else {
            // Redireciona para login em caso de falta de autorização
            handleUnauthorized();
            return response;
          }
        }
        

        if (!response.data) {
          logError(
            '[interceptors.server_error] Response missing decoded data',
            response
          );

          return response;
        }

        // Ignora erros de exceção que já são tratados
        if (response.data.reason === 'exception') {
          return response;
        }

        // Lista de erros aceitáveis
        const acceptableErrors = [
          200, 201, 202, 204, 206, 301, 302, 303, 304, 307, 308, 100,
        ];

        // Trata erros fora dos aceitáveis
        if (!acceptableErrors.includes(response.status)) {
          if (response.data.error === 'token_invalid') {
            handleTokenInvalid();
          } else {
            logError(
              `[interceptors.server_error] Error #${response.status}`,
              response.data
            );
          }
        }

        return response;
      }

      function handleEmptyResponse() {
        logError('[interceptors.server_error] Empty response received!');
        return null;
      }

      function handleUnauthorized() {
        clearStorageAndRedirect('/login');
      }

      function handleTokenInvalid() {
        clearStorageAndRedirect('/');
      }

      function clearStorageAndRedirect(url) {
        // Remove todas as chaves manualmente
        Object.keys(localStorage).forEach((key) => {
          localStorage.removeItem(key);
        });
        window.localStorage.clear();
        window.location.href = url;
      }

      function logError(message, details) {
        if (details) {
          console.error(message, details);
        } else {
          console.error(message);
        }
      }

      // Exporta as funções de resposta e erro
      this.response = handleResponse;
      this.responseError = handleResponse;
    });
})();
